module.exports = __webpack_public_path__ + "static/media/emersonLogo.59a64715.jpg";